
import { useTranslation } from 'react-i18next';

const TargetSection = () => {
  const { t } = useTranslation('partnership');

  const targets = [
    { icon: 'ri-building-2-line', title: t('target.items.0.title'), description: t('target.items.0.description') },
    { icon: 'ri-briefcase-line', title: t('target.items.2.title'), description: t('target.items.2.description') },
    { icon: 'ri-user-star-line', title: t('target.items.1.title'), description: t('target.items.1.description') },
    { icon: 'ri-earth-line', title: t('target.items.3.title'), description: t('target.items.3.description') },
  ];

  return (
    <section className="py-8 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 md:mb-16">
          <span className="text-gold-600 font-semibold text-[10px] md:text-sm uppercase tracking-wider">{t('target.badge')}</span>
          <h2 className="text-lg md:text-3xl lg:text-4xl font-bold text-gray-900 mt-2 md:mt-3 mb-2 md:mb-4 font-serif">
            {t('target.title')}
          </h2>
          <p className="text-xs md:text-base text-gray-600 max-w-2xl mx-auto">
            {t('target.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-8">
          {targets.map((target, index) => (
            <div
              key={index}
              className="flex items-start bg-gray-50 rounded-xl md:rounded-2xl p-3 md:p-8 border border-gray-100 hover:border-gold-200 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-9 h-9 md:w-16 md:h-16 flex items-center justify-center bg-gradient-to-br from-gold-400 to-gold-600 rounded-lg md:rounded-xl mr-2.5 md:mr-6 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                <i className={`${target.icon} text-sm md:text-2xl text-white`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-xs md:text-lg font-bold text-gray-900 mb-0.5 md:mb-2">{target.title}</h3>
                <p className="text-[10px] md:text-sm text-gray-600 leading-relaxed">{target.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TargetSection;
